import React from 'react';
import { ChallengeDescriptionSectionContent } from 'src/types/shared/Challenge';
import config from '../../../config';

const { S3_URL } = config;

const Image: React.FC<ImageProps> = ({ data }) => {
    return (
        <div>
            <img src={`${S3_URL}/${data.content}`} className="image" alt={data.title || ''} />
            {data.title && <p>{data.title}</p>}
        </div>
    );
};

interface ImageProps {
    data: ChallengeDescriptionSectionContent;
}

export default Image;
